import React from "react";
import { Accordion as Accordion_BS } from "react-bootstrap";
import style from "./style.module.scss";

const Accordion = props => {
  const { active, onlyHeader, isHide } = props;
  return (
    <Accordion_BS
      defaultActiveKey={active}
      className={style.accordion}
      data-only-header={!!onlyHeader}
      style={
        isHide
          ? {
              display: "none",
            }
          : {}
      }
      {...props}
    >
      {props.children}
    </Accordion_BS>
  );
};

const Item = props => {
  const { children, eventKey, className, ...rest } = props;
  const _eventKey = !!eventKey ? { eventKey } : {};
  return (
    <Accordion_BS.Item {..._eventKey} className={`${style.accordion_item} ${className || ""}`} {...rest}>
      {children}
    </Accordion_BS.Item>
  );
};

const Header = props => {
  return (
    <>
      <Accordion_BS.Header className={style.Accordion_BS_header}>{props.children}</Accordion_BS.Header>
    </>
  );
};
const Body = props => {
  return <Accordion_BS.Body className={style.accordion_body}>{props.children}</Accordion_BS.Body>;
};

const Extras = props => {
  return (
    <span
      className={`${style.accordion_extras} ${props.className}`}
      onClick={ev => {
        ev.stopPropagation();
      }}
    >
      {props.children}
    </span>
  );
};

Accordion.Item = Item;
Accordion.Header = Header;
Accordion.Body = Body;
Accordion.Extras = Extras;
export default Accordion;

{
  /* <Accordion>
{selected_events?.map((__event, __event_i) => (
  <Accordion.Item
    eventKey={`${__event_i + 1}`}
    className={`${__event_i > 0 ? "-print-avoid-break" : ""}`}
  >
    <Accordion.Header>
      <span>
        Title
        <span className="small-label ml-2">(Lorem Ipsum)</span>
      </span>
      <Accordion.Extras>
        <span>Extra</span>
      </Accordion.Extras>

    </Accordion.Header>
    <Accordion.Body>
      Body
    </Accordion.Body>
  </Accordion.Item>
))}
</Accordion> */
}
